import { useQuery } from "@tanstack/react-query";
import { getMembers } from "@/lib/members-api";
import { useOrgId } from "@/lib/org-context";

export function useMembers(params?: {
  search?: string;
  page?: number;
  perPage?: number;
  enabled?: boolean;
}) {
  const { search, page, perPage, enabled = true } = params ?? {};
  const orgId = useOrgId();

  const { data, isPending } = useQuery({
    queryKey: ["members", orgId, { search, page, perPage }],
    queryFn: () => getMembers({ search, page, perPage }),
    enabled: enabled && !!orgId,
  });

  return {
    members: data?.data ?? [],
    pagination: data?.pagination ?? null,
    isPending,
  };
}
